import React, {useEffect, useState} from 'react';

import HandOffAnimatedBars from './handOffAnimatedBars';
import WidgetMentorInfoComponent from './widgetMentorInfoComponent';

import utilsService from '../../../services/utilsService';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './handOffComponent.css';

const HandOffComponent = ({
  showCloseAnim = false,
  extendedMentorDto = {},
  handOffComponentType = VIDABOO_CONSTANTS.HANDOFF_COMPONENT_TYPES.TEAM_CHAT,
  handOffText = null,
  widgetDto = {},
}) => {
  const [profileImageUrl, setProfileImageUrl] = useState(null);

  useEffect(() => {
    let manipulatedPhotoUrl = null;
    if (
      handOffComponentType ===
      VIDABOO_CONSTANTS.HANDOFF_COMPONENT_TYPES.TEAM_CHAT
    ) {
      let widgetProfilePhotoDto = null;
      const teamMentorDto = widgetDto.teamMentorsMapDto;
      const teamMentorPhotoDto =
        Object.values(teamMentorDto)[0]?.extendedMentorDto?.photoDto;
      if (teamMentorPhotoDto) {
        widgetProfilePhotoDto = teamMentorPhotoDto;
      } else if (widgetDto?.widgetAppCtrlDto?.photoDtos) {
        widgetProfilePhotoDto =
          utilsService.getPhotoDtoAndIdxByPhotoAndObjectType(
            widgetDto.widgetAppCtrlDto.photoDtos,
            VIDABOO_CONSTANTS.PHOTO_TYPES.PROFILE,
            VIDABOO_CONSTANTS.PHOTO_OBJECT_TYPES.WIDGET,
          )?.photoDto;
      }
      if (widgetProfilePhotoDto) {
        manipulatedPhotoUrl = utilsService.getPhotoManipulatedUrl(
          widgetProfilePhotoDto,
          VIDABOO_CONSTANTS.CLOUDINARY_IMAGE_MANIPULATIONS.WIDGET_MASK_IMAGE,
        );
      }
    } else if (
      handOffComponentType ===
      VIDABOO_CONSTANTS.HANDOFF_COMPONENT_TYPES.ONE_ON_ONE_CHAT
    ) {
      const mentorPhotoDto = extendedMentorDto?.photoDto;
      if (mentorPhotoDto) {
        manipulatedPhotoUrl = utilsService.getPhotoManipulatedUrl(
          mentorPhotoDto,
          VIDABOO_CONSTANTS.CLOUDINARY_IMAGE_MANIPULATIONS.WIDGET_MASK_IMAGE,
        );
      }
    }
    setProfileImageUrl(manipulatedPhotoUrl);
  }, [handOffComponentType, extendedMentorDto]);

  return (
    <div
      className={`et-hand-off-container ${showCloseAnim ? 'et-hand-off-container-close' : ''} ${handOffComponentType === VIDABOO_CONSTANTS.HANDOFF_COMPONENT_TYPES.CALL ? 'et-hand-off-container-call' : ''} ${utilsService.getIsPersonalPage() || utilsService.getIsInExpertHome() ? 'et-hand-off-container-full-screen' : ''}`}>
      <div className="et-hoc-animated-bars-wrap">
        <HandOffAnimatedBars />
      </div>
      {handOffComponentType !==
        VIDABOO_CONSTANTS.HANDOFF_COMPONENT_TYPES.CALL && (
        <>
          <div className="et-hoc-mentor-info-wrap">
            <WidgetMentorInfoComponent
              displayName={
                handOffComponentType ===
                VIDABOO_CONSTANTS.HANDOFF_COMPONENT_TYPES.TEAM_CHAT
                  ? widgetDto?.widgetAppCtrlDto?.title
                  : handOffComponentType ===
                      VIDABOO_CONSTANTS.HANDOFF_COMPONENT_TYPES.ONE_ON_ONE_CHAT
                    ? extendedMentorDto?.mentorDto?.displayName
                    : null
              }
              profileImage={profileImageUrl}
              sessionTitle={
                handOffComponentType ===
                VIDABOO_CONSTANTS.HANDOFF_COMPONENT_TYPES.TEAM_CHAT
                  ? widgetDto?.widgetAppCtrlDto?.description
                  : handOffComponentType ===
                      VIDABOO_CONSTANTS.HANDOFF_COMPONENT_TYPES.ONE_ON_ONE_CHAT
                    ? extendedMentorDto?.sessionTemplateDto?.sessionTitle
                    : null
              }
            />
          </div>
          {handOffText && (
            <div className="et-hoc-joining-txt">{handOffText}</div>
          )}
        </>
      )}
    </div>
  );
};

export default HandOffComponent;
